const supportedTools = [
  'Length',
  'EllipticalROI',
  'CircleROI',
  'Bidirectional',
  'ArrowAnnotate',
  'Angle',
  'CobbAngle',
  'Probe',
  'RectangleROI',
  'PlanarFreehandROI',
  'SplineROI',
  'LivewireContour',
  'UltrasoundDirectionalTool',
  'UltrasoundPleuraBLineTool',
  'SegmentBidirectional',
];

export default supportedTools;
